/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginWithSsoRequest } from '../../models/login-with-sso-request';
import { LoginWithSsoResult } from '../../models/login-with-sso-result';

export interface PostLoginSso$Params {
  body?: LoginWithSsoRequest;
}

export function postLoginSso(
  http: HttpClient,
  rootUrl: string,
  params?: PostLoginSso$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<LoginWithSsoResult>> {
  const rb = new RequestBuilder(rootUrl, postLoginSso.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginWithSsoResult>;
    }),
  );
}

postLoginSso.PATH = '/Authentication/login/sso';
